import { combineReducers } from 'redux';

import avisos from './avisos';
import comentaris from './comentaris';
import dataUltimaTileGeneradaRadar from './dataUltimaTileGeneradaRadar';

export default combineReducers({
    avisos,
    comentaris,
    dataUltimaTileGeneradaRadar
});



// WEBPACK FOOTER //
// ./src/reducers/avis/visualitzacio/index.js